// extracted by mini-css-extract-plugin
export default {"container":"styles_container__R6iGu","splitter":"styles_splitter__Ag-2L"};